<template>
  <j-modal
    ref="from"
    :title="title"
    :width="800"
    :visible="visible"
    :destroyOnClose="true"
    :closable="true"
    :confirmLoading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-form-model
      ref="form"
      :model="form"
      @keyup.enter.native="handleOk"
      v-if="!showResult"
      :rules="rules"
      layout="vertical"
    >
      <!-- 警告メッセージ区域-begin -->
      <div style="margin-bottom: 12px">
        <a-alert type="warning" :showIcon="true" style="border: none">
          <div slot="message">
            <p>{{ msg }}</p>
          </div>
        </a-alert>
      </div>
      <!-- 警告メッセージ区域-end -->

      <template v-if="title == '批量委派'">
        <a-form-model-item prop="userIdTo" label="委派对象" style="margin-top: 18px">
          <j-input-popup
            v-model="selectUserListTo"
            component="SelectUserTreeModal"
            placeholder="请选择委派对象"
            :params="{
              multiFlg: '0',
              departFlg: '1',
              selectUserList: selectUserListTo,
            }"
            @change="changeSelectUserListTo"
          ></j-input-popup>
        </a-form-model-item>

        <a-form-model-item prop="comment">
          <span slot="label">
            <span>补充说明</span>
            <JSlash></JSlash>
            <span>附言</span>
          </span>

          <a-textarea
            v-model="form.comment"
            :autoSize="{ minRows: 6 }"
            placeholder="需要补充说明或附言的时候请填写"
            @keyup.enter.stop
            :maxLength="900"
          ></a-textarea>
        </a-form-model-item>
      </template>

      <template v-else>
        <a-form-model-item :labelCol="{ span: 0 }">
          <a-textarea
            v-model="form.comment"
            :autoSize="{ minRows: 6 }"
            placeholder="需要补充说明或附言的时候请填写"
            @keyup.enter.stop
            :maxLength="900"
          />
        </a-form-model-item>
      </template>
    </a-form-model>
    <table class="tb-result" v-if="showResult">
      <tr v-for="currentAction in actionInfo" :key="currentAction.processInstanceId">
        <td style="color: var(--color-primary)">{{ currentAction.processInstanceId }}</td>
        <td>
          {{
            currentAction.applyName ||
            currentAction.processDefinitionName ||
            $getTextByLocale($route.meta.title).replaceAll($t('disp.btn.search'), $t('disp.flow.apply'))
          }}
        </td>
        <td v-if="currentAction.result == -1 || currentAction.result == 0">
          <a-icon type="loading" style="color: rgb(250, 173, 20)" />
        </td>
        <td v-if="currentAction.result == 1"><a-icon type="check" style="color: rgb(82, 196, 26)" /></td>
        <td v-if="currentAction.result == 2">
          <a-icon type="close" style="color: rgb(245, 34, 45)" />
        </td>
        <td class="ignore-title-check">
          <div
            v-if="currentAction.resultMsg"
            class="tb-result-msg"
            :title="
              currentAction.resultMsg.toLowerCase().indexOf('global lock wait timeout') >= 0
                ? '处理超时，请再次尝试。若无法解决，请联系系统管理员。'
                : currentAction.resultMsg
            "
          >
            {{
              currentAction.resultMsg.toLowerCase().indexOf('global lock wait timeout') >= 0
                ? '处理超时，请再次尝试。若无法解决，请联系系统管理员。'
                : currentAction.resultMsg
            }}
          </div>
          <!-- <div v-else-if="currentAction.retry > 0">リトライ中：第 {{ currentAction.retry }} 回</div> -->
        </td>
      </tr>
    </table>
  </j-modal>
</template>

<script>
import { putAction, postAction, getAction } from '@/api/manage'

class formDef {
  processInstanceId = undefined
  endDateTimestamp = undefined
  userIdFrom = undefined
  userIdTo = undefined
  comment = undefined
}

export default {
  name: 'CommentModal',
  mixins: [],
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      showResult: false,
      // タイトル
      title: '',
      // 親画面からURL
      url: '',
      // 親画面から処理情報
      actionInfo: [],
      // 親画面からメッセージ
      msg: '',
      form: new formDef(),
      selectUserListTo: [],
      //rules: {
      //  userIdTo: [this._r.required],
      //},
      // コメントURL
      commentUrl: 'flow/applyComment',
      needComment: false,
      needCheckCanApprove: false,
      errMessageId: '',
      approveFlag: this.$getLoginUser().approveFlag,
    }
  },
  methods: {
    handleOpen(title, actionInfo, url, msg, needComment, needCheckCanApprove) {
      this.title = title
      this.url = url
      this.actionInfo = actionInfo
      this.errMessageId = ''
      this.visible = true
      this.showResult = false
      this.msg = msg
      this.needComment = needComment
      this.needCheckCanApprove = needCheckCanApprove

      // -1：実行待ち、0：実行中、1：成功、2：失敗、3：対象外
      for (var currentAction of this.actionInfo) {
        currentAction.result = -1
        currentAction.resultMsg = ''
        currentAction.retry = 0
      }
    },
    changeSelectUserListTo(selected) {
      if (selected.length == 0) {
        this.form.userIdTo = ''
      } else {
        this.form.userIdTo = selected[0].value
      }
    },
    handleCancel() {
      if (this.showResult) {
        this.$emit('ok')
      }
      this.visible = false
    },
    handleOk() {
      if (this.showResult) {
        //　閉じる
        this.visible = false
        this.$emit('ok')
        return
      }

      if (this.title == '批量委派' && !this.form.userIdTo) {
        return this.$message.warning('请选择委派对象')
      }

      if (this.needComment && !this.form.comment) {
        return this.$message.warning(this.$t('msg.flow.refuse.commentmsg'))
      }

      if (this.loading) {
        return
      } else {
        this.showResult = true
        this.loading = true
      }

      // 取消、保留、承認、再申請、却下、引戻処理
      console.time()
      this.doBatchAction()
    },
    doBatchAction() {
      var interval = setInterval(() => {
        // 等待执行任务
        var waitAction = XEUtils.filter(this.actionInfo, (item) => item.result == -1)

        // 执行中任务
        var runningAction = XEUtils.filter(this.actionInfo, (item) => item.result == 0)
        // 为避免同时处理过多的流程造成后端拥堵,限制同时执行任务数为3
        if (runningAction.length >= 3) {
          return
        }

        // 尚有等待执行任务的时候
        if (waitAction.length > 0) {
          var currentAction = waitAction[0]
          currentAction.result = 0
          console.info('doBatchAction：' + currentAction.processInstanceId)

          let pullbackTarget = {}
          if (currentAction.pullbackList && currentAction.pullbackList.length > 0) {
            pullbackTarget = currentAction.pullbackList[0]
          }

          postAction(this.url, {
            id: currentAction.id,
            taskId: currentAction.id,
            procInstId: currentAction.processInstanceId,
            processInstanceId: currentAction.processInstanceId,
            executionId: currentAction.executionId,
            userIdFrom: this.form.userIdFrom,
            userIdTo: this.form.userIdTo,
            comment: this.form.comment,
            endDateTimestamp: currentAction.endDateTimestamp || this.form.endDateTimestamp,
            needCheckCanApprove: this.needCheckCanApprove,
            pullbackTarget: pullbackTarget,
          }).then((res) => {
            if (res.success) {
              if (this.title == this.$t('disp.flow.approveBatch')) {
                // 承认的时候,继续确认是否需要自动承认
                this.doAutoConfirm(currentAction)
              } else {
                currentAction.result = 1

                // 强制刷新页面
                this.showResult = false
                this.showResult = true

                // 递归执行下一个任务
                // this.doBatchAction()
              }
            } else {
              if (currentAction.retry >= 10) {
                currentAction.result = 2
                currentAction.resultMsg = this.$t(res.message)
              } else {
                setTimeout(() => {
                  currentAction.result = -1
                  currentAction.retry = currentAction.retry + 1
                }, 3000)
              }

              // 强制刷新页面
              this.showResult = false
              this.showResult = true

              // 递归执行下一个任务
              // this.doBatchAction()
            }
          })
        }
        // 已无等待执行任务的时候
        else {
          if (
            XEUtils.filter(this.actionInfo, (item) => item.result == 1).length +
              XEUtils.filter(this.actionInfo, (item) => item.result == 2).length ==
            this.actionInfo.length
          ) {
            clearInterval(interval)
            // ローディング終了
            this.loading = false
            console.timeEnd()
          }
        }
      }, 100)
    },
    doAutoConfirm(currentAction) {
      console.info('doAutoConfirm：' + currentAction.processInstanceId)

      // 自動承認フラグは「しない」場合
      if (this.approveFlag && this.approveFlag == '0') {
        // 自動承認できるタスクがない場合
        currentAction.result = 1

        // 强制刷新页面
        this.showResult = false
        this.showResult = true

        // 递归执行下一个任务
        // this.doBatchAction()
        return
      }

      postAction('/flow/task/getAutoConfirmTask', {
        procInstId: currentAction.processInstanceId,
      }).then((res) => {
        if (res.result) {
          // 自動承認できるタスクがある場合
          this.taskId = res.result.id
          this.executionId = res.result.executionId

          postAction(this.url, {
            taskId: res.result.id,
            procInstId: currentAction.processInstanceId,
            executionId: res.result.executionId,
            comment: null,
            autoConfirm: true,
          }).then((res) => {
            // 承認成功の場合
            if (res.success) {
              return this.doAutoConfirm(currentAction)
            } else {
              if (currentAction.retry >= 10) {
                currentAction.result = 2
                currentAction.resultMsg = this.$t(res.message)
              } else {
                setTimeout(() => {
                  currentAction.retry = currentAction.retry + 1
                  this.doAutoConfirm(currentAction)
                }, 3000)
              }

              // 强制刷新页面
              this.showResult = false
              this.showResult = true

              // 递归执行下一个任务
              // this.doBatchAction()
            }
          })
        } else {
          // 自動承認できるタスクがない場合
          currentAction.result = 1

          // 强制刷新页面
          this.showResult = false
          this.showResult = true

          // 递归执行下一个任务
          // this.doBatchAction()
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
.tb-result {
  width: auto;
  margin: auto;

  td {
    padding: 0 20px;
    height: 30px;

    .tb-result-msg {
      max-width: 300px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #f5222d;
    }
  }
}
</style>
